import React from 'react';
import { NotificationContainer } from '../Common/Notifications';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { NotificationVariant } from '../Common/Notifications/types';

type ComponentProps = {
  successBanner?: boolean;
  notSavedBanner?: boolean;
  requestFailureBanner?: boolean;
};

export const SuggestAppBanner: React.FC<ComponentProps> = ({
  successBanner,
  notSavedBanner,
  requestFailureBanner,
}): JSX.Element => {
  const [t] = useTranslation();
  return (
    <div className={styles.banner} role='alert'>
      {successBanner && (
        <NotificationContainer
          notificationData={{
            title: "",
            body: t('suggest_app.success_banner'),
            variant: NotificationVariant.Green,
          }}
          notificationProperties={{
            closeTimer: false,
            closeable: false
          }}
        />
      )}
      {requestFailureBanner && (
        <NotificationContainer
          notificationData={{
            title: "",
            body: t('suggest_app.request_failure_banner'),
            variant: NotificationVariant.Red,
          }}
          notificationProperties={{
            closeTimer: false,
            closeable: false
          }}
        />
      )}
      {notSavedBanner && (
        <NotificationContainer
          notificationData={{
            title: "",
            body: t('suggest_app.not_saved_banner'),
            variant: NotificationVariant.Yellow,
          }}
          notificationProperties={{
            closeTimer: false,
            closeable: false
          }}
        />
      )}
    </div>
  );
};
